import React from "react";
import { FooterNavSection } from "./FooterNavSection";
export const FooterNavV2_6 = ({ navSections }) => (React.createElement("nav", { className: "footer-navigation" }, navSections.map((section, index) => (React.createElement(FooterNavSection, { key: index, title: section.title, links: section.links })))));
